/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ProductVariantSummary {
  activeFeedbackId?: number;
  brandEquity?: number;
  brandId?: number;
  brandLogoImage?: string;
  brandName?: string;
  brandSummary?: string;
  costPrice?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  defaultProductVariantId?: number;
  descriptionArticleId?: number;
  displayOrder?: number;
  expiration?: string;
  externalId?: number;
  externalStoreUrl?: string;
  internalEAN?: string;
  isSellable?: boolean;
  isTradeable?: boolean;
  maxTradesPerPerson?: number;
  ncm?: string;
  orderCount?: number;
  productId?: number;
  productName?: string;
  productSummary?: string;
  productVariantId?: number;
  productVariantName?: string;
  ratingAverage?: number;
  reviewCount?: number;
  salePrice?: number;
  showOnWebSite?: boolean;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  variantSummary?: string;
  weight?: number;
}
